<main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
  <app-navigation></app-navigation>
  <router-outlet></router-outlet>
</main>
